import React from "react";
import NewProfileCard from "../Components/ProfileCard/NewProfileCard";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import Typewriter from "typewriter-effect";
import CreateProfileForm from "../Components/CreateProfileForm";
import { defaultProfile } from "../scripts/Profile";
import { useAuth } from "../Components/AuthContext";
import Loader from "../Components/Loader";
import { Drawer } from "vaul";

const NewProfile = () => {
  const { userLoggedIn, currentUser, setCardId } = useAuth();

  const defaultPerson = {
    firstName: "Samantha",
    lastName: "Jackson",
    company: "Software Engineer @ Penpal",
    position: "Software Engineer",
    college: "University of Rochester",
    major: "Computer Science",
    email: "samjackson@gmail.com",
    linkedIn: "https://linkedin.com/in/sam-jackie",
    instagram: "https://instagram.com/sam002",
    github: "https://github.com/tamuda",
    portfolio: "penpal.cards",
    resume: "google.com",
    phone: "585-867-2324",
    website: "https://penpal.cards",
    imageUrl:
      "https://lightroom.adobe.com/v2c/spaces/ac25eaa911074b529a3c1d15977a15e5/assets/b42c3222624c42e5adab674de274d15b/revisions/13aa032a68e445c7ae7580204a399bbf/renditions/1cb7d23e0c1db08e3bf37217c2ab7e7f",
    headline: "Loves Penpal Cards",
  };

  //use effect
  const { id } = useParams(); //
  const { orgId } = useParams(); //
  const [person, setPerson] = useState(false); // [person, setPerson]
  const [loading, setLoading] = useState(true); // [loading, setLoading
  const cardId = id;
  const navigate = useNavigate();
  //get user info from api
  const getUserInfo = async (id) => {
    if (id == "demo") {
      setPerson(defaultPerson);
      return defaultPerson;
    }
    if (id.length !== 16) {
      window.location.replace("/");
      return;
    }
    try {
      //post request with cardID

      const response = await axios.post(
        `${process.env.REACT_APP_PUBLIC_BACKEND_URL}get_user_by_card_id`,

        { cardId: cardId }
      );

      if (response.status === 200) {
        const data = response.data;

        // Check if this is a gift card - redirect to gift feed
        // The backend endpoint already supports cardId lookup, so we can use it directly in the URL
        if (data.cardType === "gift" || data.profiles?.[0]?.cardType === "gift") {
          console.log("Gift card detected, redirecting to gift feed with cardId");
          window.location.replace(`/gift/${id}`);
          return;
        }

        const profile = data.profiles[0];

        // Merge root email with profile data so we can save contacts to the correct user
        const personWithRootEmail = {
          ...profile,
          email: data.email, // Use root email for database queries
          cardId: data.cardId,
          _id: data._id,
          // Ensure business fields are available
          cardType: profile.cardType || data.cardType || "individual",
          businessPurpose: profile.businessPurpose || data.businessPurpose || "",
          businessName: profile.businessName || data.businessName || "",
          googleReviewLink: profile.googleReviewLink || data.googleReviewLink || "",
        };

        setPerson(personWithRootEmail);
      }
    } catch (error) {
      //catch error

      setPerson(false);
    }
  };

  const [links, setLinks] = useState([]);
  const getLinks = async (organizationId) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_PUBLIC_BACKEND_URL}get_org_links`,
        { organizationId: organizationId }
      );
      if (response.status === 200) {
        setLinks(response.data);
      }
    } catch (error) {
      console.error("Error retrieving links:", error);
    }
  };

  const increment_visits = async (orgId, cardTap = true) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_PUBLIC_BACKEND_URL}increment_visits`,
        {
          orgId: orgId,
          cardTap: cardTap,
        }
      );
      if (response.status === 200) {
        // Visits incremented
      }
    } catch (error) {
      console.error("Error incrementing visits:", error);
    }
  };

  //use effect
  useEffect(() => {
    const fetchData = async () => {
      await getUserInfo(id);

      getLinks(orgId);
      increment_visits(orgId);
      //wait a second
      setTimeout(() => {
        setLoading(false);
      }, 3000);
    };
    fetchData();
  }, [id]);

  if (loading) {
    const words = [
      "Bonjour",
      "Hello",
      "Aloha",
      "Salam",
      "Olá",
      "Namaste",
      "Konnichiwa",
      "Ciao",
    ];
    const randomWord = () => {
      return words[Math.floor(Math.random() * words.length)];
    };
    return (
      <div className="flex flex-col gap-8">
        <motion.div
          className="h-full w-full lg:mt-76 mt-60 text-7xl flex flex-col justify-center items-center  font-extralight"
          id="hello"
          initial={{ opacity: 0, y: 60 }} // Start 50 pixels below the final position and with zero opacity
          viewport={{ once: true, amount: 0.5 }}
          whileInView={{
            opacity: 1,
            y: 0,
            transition: { duration: 0.5, ease: "easeOut" },
          }} // Animate to full opacity and final position at y=0
        >
          <Typewriter
            onInit={(typewriter) => {
              typewriter
                //type random word
                  .typeString(randomWord())
                  .pauseFor(3500)
                  .deleteAll()
                  .start();
            }}
          />
        </motion.div>
        <Loader height={70} width={70} />
      </div>
    );
  }

  if (!person) {
    setCardId(cardId);
    return (
      <div className="h-full w-full lg:mt-76 mt-60">
        <CreateProfile />
      </div>
    );
  }

  // Check card type and show appropriate view
  const cardType = person.cardType || "individual";
  const businessPurpose = person.businessPurpose || "";
  const hasBusinessName =
    person.businessName && person.businessName.trim() !== "";
  const hasFirstName = person.firstName && person.firstName.trim() !== "";
  const hasGoogleReviewLink =
    person.googleReviewLink && person.googleReviewLink.trim() !== "";

  // Business cards - show business-specific views (check first, before individual check)
  if (cardType === "business") {
    if (businessPurpose === "google-reviews") {
      return <BusinessReviewView person={person} />;
    } else if (businessPurpose === "leads") {
      return <BusinessLeadsView person={person} />;
    } else if (businessPurpose === "social-media") {
      return <BusinessSocialMediaView person={person} />;
    }
    // If business card but purpose not set, default to review view if businessName exists
    if (hasBusinessName) {
      return <BusinessReviewView person={person} />;
    }
  }

  // Fallback: if we have businessName or googleReviewLink but cardType isn't set, treat as business review
  if ((hasBusinessName || hasGoogleReviewLink) && !hasFirstName) {
    return <BusinessReviewView person={person} />;
  }

  return (
    <div>
      <NewProfileCard person={person} links={links} />
    </div>
  );
};

// Business Review View Component
const BusinessReviewView = ({ person }) => {
  const reviewLink = person.googleReviewLink;
  const businessName = person.businessName || "Business";
  const imageUrl = person.imageUrl;
  const [currentTime, setCurrentTime] = useState(new Date());
  const [drawerOpen, setDrawerOpen] = useState(false);

  // Update time every second
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // Auto-open drawer after 1 second
  useEffect(() => {
    const timer = setTimeout(() => {
      setDrawerOpen(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const formatTime = () => {
    return currentTime.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  };

  const formatDate = () => {
    return currentTime.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
    });
  };

  const handleReviewClick = () => {
    if (reviewLink) {
      window.open(reviewLink, "_blank");
    }
  };

  // Generate gradient from brand color
  const generateGradient = (baseColor) => {
    const hex = baseColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Calculate luminance to determine if color is dark or light
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    const isDark = luminance < 0.5;

    let shade1R, shade1G, shade1B, shade2R, shade2G, shade2B;

    if (isDark) {
      // For dark colors, create darker variations
      shade1R = Math.min(255, r + 100);
      shade1G = Math.min(255, g + 100);
      shade1B = Math.min(255, b + 100);
      shade2R = Math.min(255, r + 50);
      shade2G = Math.min(255, g + 50);
      shade2B = Math.min(255, b + 50);
    } else {
      // For light colors, create lighter variations
      shade1R = Math.min(255, r + 40);
      shade1G = Math.min(255, g + 40);
      shade1B = Math.min(255, b + 40);
      shade2R = Math.min(255, r + 20);
      shade2G = Math.min(255, g + 20);
      shade2B = Math.min(255, b + 20);
    }

    const shade1 = `rgb(${shade1R}, ${shade1G}, ${shade1B})`;
    const shade2 = `rgb(${shade2R}, ${shade2G}, ${shade2B})`;
    const base = `rgb(${r}, ${g}, ${b})`;

    return isDark 
      ? `linear-gradient(to bottom right, ${shade1}, ${shade2}, ${base})`
      : `linear-gradient(to bottom right, ${shade1}, ${shade2}, ${base})`;
  };

  // Calculate if text should be white or black based on background luminance
  const getTextColor = (hexColor) => {
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Calculate relative luminance (WCAG formula)
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // Return white for dark backgrounds, black for light backgrounds
    return luminance > 0.5 ? '#1f2937' : '#ffffff'; // gray-800 or white
  };

  const brandColor = person.socialMediaConfig?.brandColor || "#2563EB";
  const gradientStyle = generateGradient(brandColor);
  const textColor = getTextColor(brandColor);

  return (
    <div className="flex flex-col h-full items-center min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 justify-start p-6 pb-32">
      <div className="max-w-md w-full relative z-10">
        {/* Header Card with Animated Gradient */}
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="relative bg-white rounded-3xl shadow-sm border border-gray-100 p-8 mb-6 overflow-hidden"
        >
          {/* Animated Gradient Background */}
          <div className="absolute inset-0">
            <div 
              className="absolute inset-0 animate-gradient-shift"
              style={{
                background: gradientStyle,
                backgroundSize: '200% 200%',
              }}
            ></div>
          </div>
          
          {/* Content */}
          <div className="relative z-10 text-center">
            {imageUrl && (
              <motion.div
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
                className="relative inline-block mb-5"
              >
                {/* White Card Container */}
                <div className="bg-white p-2 rounded-2xl shadow-md">
                  <img
                    src={imageUrl}
                    alt={businessName}
                    className="w-24 h-24 rounded-xl object-cover"
                  />
                </div>
              </motion.div>
            )}
            <motion.h1
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="text-2xl font-semibold mb-2 tracking-tight"
              style={{ color: textColor }}
            >
              {businessName}
            </motion.h1>
            <motion.p
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="text-sm font-medium"
              style={{ color: textColor, opacity: 0.8 }}
            >
              {person.headline || ""}
            </motion.p>
          </div>
        </motion.div>

        {/* Banner Card with Time */}
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="relative bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden h-48 mb-6"
        >
          {/* Banner Image Background */}
          <img
            src={
              person.socialMediaConfig?.bannerImage ||
              require("../Assets/img/xmas/house.png")
            }
            alt="banner"
            className="absolute inset-0 w-full h-full object-cover"
          />
          
          {/* Time Overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent flex flex-col justify-end p-6">
            <div className="text-white">
              <div className="text-3xl font-bold tracking-tight mb-1">
                {formatTime()}
              </div>
              <div className="text-sm opacity-90">
                {formatDate()}
              </div>
            </div>
          </div>
        </motion.div>

        {/* Review Button - Shown when drawer is closed */}
        {!drawerOpen && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6"
          >
            <p className="text-gray-600 text-center mb-4 font-semibold">
              Help us grow with your feedback
            </p>
            <button
              onClick={() => setDrawerOpen(true)}
              className="w-full text-white font-semibold py-4 px-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-200 active:scale-[0.98]"
              style={{ backgroundColor: '#2563EB' }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#1d4ed8'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#2563EB'}
            >
              Write a Review
            </button>
          </motion.div>
        )}
      </div>

      {/* iOS-Style Drawer for Review Button */}
      <Drawer.Root open={drawerOpen} onOpenChange={setDrawerOpen}>
        <Drawer.Portal>
          <Drawer.Overlay className="fixed inset-0 bg-black/40 z-40" />
          <Drawer.Content
            className="fixed bottom-0 left-0 right-0 bg-white rounded-t-3xl shadow-2xl border-t border-gray-100 max-w-md mx-auto outline-none z-50"
            style={{ maxHeight: "50vh" }}
          >
            {/* Drawer Handle */}
            <div className="flex justify-center pt-3 pb-2">
              <div className="w-10 h-1 bg-gray-300 rounded-full"></div>
            </div>

            {/* Drawer Content */}
            <div className="px-6 pb-8">
              <h3 className="text-lg font-semibold text-gray-900 mb-4 text-center">
                Leave a Review
              </h3>

              <button
                onClick={handleReviewClick}
                disabled={!reviewLink}
                className="w-full text-white font-semibold py-4 px-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-200 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed"
                style={{ backgroundColor: '#2563EB' }}
                onMouseEnter={(e) => !reviewLink ? null : e.currentTarget.style.backgroundColor = '#1d4ed8'}
                onMouseLeave={(e) => !reviewLink ? null : e.currentTarget.style.backgroundColor = '#2563EB'}
              >
                {reviewLink ? "Write a Review on Google" : "Review Link Not Available"}
              </button>

              {!reviewLink && (
                <p className="text-sm text-gray-500 mt-4 text-center">
                  Please contact the business owner to set up reviews.
                </p>
              )}
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
};

// Business Leads View Component
// Business Leads View Component
const BusinessLeadsView = ({ person }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [step, setStep] = useState(1);
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const leadCaptureConfig = person.leadCapture || {
    tagline: "Join our mailing list",
    phoneEnabled: false,
    questions: [],
  };

  const hasQuestions =
    leadCaptureConfig.questions && leadCaptureConfig.questions.length > 0;

  const handleStep1Submit = async (e) => {
    e.preventDefault();
    if (!name || !email) return;

    setSubmitting(true);
    try {
      // Get location (optional - won't block if denied)
      let location = null;
      try {
        if (navigator.geolocation) {
          const position = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject, {
              timeout: 5000,
              enableHighAccuracy: false,
            });
          });

          // Reverse geocode to get city name
          const lat = position.coords.latitude;
          const lon = position.coords.longitude;

          try {
            const geoResponse = await fetch(
              `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
            );
            const geoData = await geoResponse.json();

            location = {
              city:
                geoData.address?.city ||
                geoData.address?.town ||
                geoData.address?.village ||
                "Unknown",
              state: geoData.address?.state || "",
              country: geoData.address?.country || "",
              latitude: lat,
              longitude: lon,
              timestamp: new Date().toISOString(),
            };
          } catch (geoApiError) {
            // If reverse geocoding fails, just use coordinates
            location = {
              city: "Unknown",
              latitude: lat,
              longitude: lon,
              timestamp: new Date().toISOString(),
            };
          }
        }
      } catch (geoError) {
        // Location not available, continue without location
      }

      const contact = {
        name,
        email,
        phone: phone || "",
        exchanged: true, // Treat as exchanged contact
        timestamp: new Date().toISOString(),
        location: location,
      };

      await axios.post(
        `${process.env.REACT_APP_PUBLIC_BACKEND_URL}add_contact`,
        {
          email: person.email, // Card holder's email
          contact: contact,
        }
      );

      if (hasQuestions) {
        setStep(2);
      } else {
        setSubmitted(true);
      }
    } catch (error) {
      console.error("Error saving lead:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleStep2Submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      // Format answers into notes
      const formattedAnswers = leadCaptureConfig.questions
        .map((q) => {
          const answer = answers[q.id] || "No answer";
          return `${q.text}\nAnswer: ${answer}`;
        })
        .join("\n\n");

      // Update contact with notes
      // We use update_contact which requires the contact's email to identify them
      await axios.post(
        `${process.env.REACT_APP_PUBLIC_BACKEND_URL}update_contact`,
        {
          email: person.email, // Card holder's email (owner)
          contactEmail: email, // The lead's email (identifier)
          updatedContact: {
            notes: formattedAnswers,
          },
        }
      );

      setSubmitted(true);
    } catch (error) {
      console.error("Error saving answers:", error);
      // Even if updating notes fails, the contact was saved in step 1.
      // We'll just show success to the user but log the error.
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  // Generate gradient from brand color
  const generateGradient = (baseColor) => {
    const hex = baseColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    const isDark = luminance < 0.5;

    let shade1R, shade1G, shade1B, shade2R, shade2G, shade2B;

    if (isDark) {
      shade1R = Math.min(255, r + 100);
      shade1G = Math.min(255, g + 100);
      shade1B = Math.min(255, b + 100);
      shade2R = Math.min(255, r + 50);
      shade2G = Math.min(255, g + 50);
      shade2B = Math.min(255, b + 50);
    } else {
      shade1R = Math.min(255, r + 40);
      shade1G = Math.min(255, g + 40);
      shade1B = Math.min(255, b + 40);
      shade2R = Math.min(255, r + 20);
      shade2G = Math.min(255, g + 20);
      shade2B = Math.min(255, b + 20);
    }

    const shade1 = `rgb(${shade1R}, ${shade1G}, ${shade1B})`;
    const shade2 = `rgb(${shade2R}, ${shade2G}, ${shade2B})`;
    const base = `rgb(${r}, ${g}, ${b})`;

    return `linear-gradient(to bottom right, ${shade1}, ${shade2}, ${base})`;
  };

  const getTextColor = (hexColor) => {
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? '#1f2937' : '#ffffff';
  };

  const brandColor = person.socialMediaConfig?.brandColor || "#2563EB";
  const gradientStyle = generateGradient(brandColor);
  const textColor = getTextColor(brandColor);

  if (submitted) {
    return (
      <div className="flex flex-col h-full items-center min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 justify-center p-6">
        <div className="max-w-md w-full">
          {/* Success Header Card */}
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="relative bg-white rounded-3xl shadow-sm border border-gray-100 p-8 text-center overflow-hidden"
          >
            {/* Animated Gradient Background */}
            <div 
              className="absolute inset-0 animate-gradient-shift"
              style={{
                background: gradientStyle,
                backgroundSize: '200% 200%',
              }}
            ></div>

            {/* Content */}
            <div className="relative z-10">
              {person.imageUrl && (
                <div className="relative inline-block mb-5">
                  <div className="bg-white p-2 rounded-2xl shadow-md">
                    <img
                      src={person.imageUrl}
                      alt={person.businessName || "Business"}
                      className="w-24 h-24 rounded-xl object-cover"
                    />
                  </div>
                </div>
              )}
              <h1 
                className="text-2xl font-semibold mb-4 tracking-tight"
                style={{ color: textColor }}
              >
                {person.businessName || "Business"}
              </h1>
              <div className="text-green-600 mb-4">
                <svg
                  className="w-16 h-16 mx-auto"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
              <p className="text-lg" style={{ color: textColor }}>Thank you!</p>
              <p className="mt-2" style={{ color: textColor, opacity: 0.8 }}>We'll be in touch soon.</p>
            </div>
          </motion.div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full items-center min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 justify-start p-6">
      <div className="max-w-md w-full">
        {/* Header Card with Animated Gradient */}
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="relative bg-white rounded-3xl shadow-sm border border-gray-100 p-8 mb-6 overflow-hidden"
        >
          {/* Animated Gradient Background */}
          <div 
            className="absolute inset-0 animate-gradient-shift"
            style={{
              background: gradientStyle,
              backgroundSize: '200% 200%',
            }}
          ></div>
          
          {/* Content */}
          <div className="relative z-10 text-center">
            {person.imageUrl && (
              <motion.div
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
                className="relative inline-block mb-5"
              >
                <div className="bg-white p-2 rounded-2xl shadow-md">
                  <img
                    src={person.imageUrl}
                    alt={person.businessName || "Business"}
                    className="w-24 h-24 rounded-xl object-cover"
                  />
                </div>
              </motion.div>
            )}
            <motion.h1
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="text-2xl font-semibold mb-2 tracking-tight"
              style={{ color: textColor }}
            >
              {person.businessName || "Business"}
            </motion.h1>
            <motion.p
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="text-sm font-medium"
              style={{ color: textColor, opacity: 0.8 }}
            >
              {person.headline || ""}
            </motion.p>
          </div>
        </motion.div>

        {/* Form Card */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
          <p className="text-gray-600 text-center mb-6 font-semibold">
            {leadCaptureConfig.tagline || "Join our mailing list"}
          </p>

        {step === 1 ? (
          <form onSubmit={handleStep1Submit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Name
              </label>
              <input
                type="text"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                placeholder="Your name"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                placeholder="your@email.com"
              />
            </div>
            {leadCaptureConfig.phoneEnabled && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Phone{" "}
                  <span className="text-gray-400 font-normal">(Optional)</span>
                </label>
                <input
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                  placeholder="+1 (555) 000-0000"
                />
              </div>
            )}
            <button
              type="submit"
              disabled={submitting}
              className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white font-semibold py-3 px-6 rounded-lg transition-colors mt-6"
            >
              {submitting
                ? "Processing..."
                : hasQuestions
                ? "Next"
                : "Submit"}
            </button>
          </form>
        ) : (
          <form onSubmit={handleStep2Submit} className="space-y-4">
            {leadCaptureConfig.questions.map((q) => (
              <div key={q.id}>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  {q.text}
                </label>
                <input
                  type="text"
                  value={answers[q.id] || ""}
                  onChange={(e) =>
                    setAnswers({ ...answers, [q.id]: e.target.value })
                  }
                  maxLength={200}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                  placeholder="Your answer"
                />
              </div>
            ))}
            <button
              type="submit"
              disabled={submitting}
              className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white font-semibold py-3 px-6 rounded-lg transition-colors mt-6"
            >
              {submitting ? "Submitting..." : "Submit Answers"}
            </button>
          </form>
        )}
        </div>
      </div>
    </div>
  );
};

// Business Social Media View Component
const BusinessSocialMediaView = ({ person }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  // Update time every second
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = () => {
    return currentTime.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  };

  const formatDate = () => {
    return currentTime.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
    });
  };
  const socialLinks = [
    {
      name: "LinkedIn",
      url: person.linkedIn,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
        </svg>
      ),
      color: "from-blue-500 to-blue-600",
    },
    {
      name: "Instagram",
      url: person.instagram,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
        </svg>
      ),
      color: "from-pink-500 to-purple-600",
    },
    {
      name: "X",
      url: person.x,
      icon: (
        <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 20 20">
          <path d="M11.4678 8.77491L17.2961 2H15.915L10.8543 7.88256L6.81232 2H2.15039L8.26263 10.8955L2.15039 18H3.53159L8.87581 11.7878L13.1444 18H17.8063L11.4675 8.77491H11.4678ZM9.57608 10.9738L8.95678 10.0881L4.02925 3.03974H6.15068L10.1273 8.72795L10.7466 9.61374L15.9156 17.0075H13.7942L9.57608 10.9742V10.9738Z" />
        </svg>
      ),
      color: "from-gray-800 to-gray-900",
    },
    {
      name: "Facebook",
      url: person.facebook,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
        </svg>
      ),
      color: "from-blue-600 to-blue-700",
    },
    {
      name: "TikTok",
      url: person.tiktok,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
        </svg>
      ),
      color: "from-gray-900 to-black",
    },
    {
      name: "Website",
      url: person.portfolio,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1 16.057v-3.057h2.994c-.059 1.143-.212 2.24-.456 3.279-.823-.12-1.674-.188-2.538-.222zm1.957 2.162c-.499 1.33-1.159 2.497-1.957 3.456v-3.62c.666.028 1.319.081 1.957.164zm-1.957-7.219v-3.015c.868-.034 1.721-.103 2.548-.224.238 1.027.389 2.111.446 3.239h-2.994zm0-5.014v-3.661c.806.969 1.471 2.15 1.971 3.496-.642.084-1.3.137-1.971.165zm2.703-3.267c1.237.496 2.354 1.228 3.29 2.146-.642.234-1.311.442-2.019.607-.344-.992-.775-1.91-1.271-2.753zm-7.241 13.56c-.244-1.039-.398-2.136-.456-3.279h2.994v3.057c-.865.034-1.714.102-2.538.222zm2.538 1.776v3.62c-.798-.959-1.458-2.126-1.957-3.456.638-.083 1.291-.136 1.957-.164zm-2.994-7.055c.057-1.128.207-2.212.446-3.239.827.121 1.68.19 2.548.224v3.015h-2.994zm1.024-5.179c.5-1.346 1.165-2.527 1.97-3.496v3.661c-.671-.028-1.329-.081-1.97-.165zm-2.005-.35c-.708-.165-1.377-.373-2.018-.607.937-.918 2.053-1.65 3.29-2.146-.496.844-.927 1.762-1.272 2.753zm-.549 1.918c-.264 1.151-.434 2.36-.492 3.611h-3.933c.165-1.658.739-3.197 1.617-4.518.88.361 1.816.67 2.808.907zm.009 9.262c-.988.236-1.92.542-2.797.9-.89-1.328-1.471-2.879-1.637-4.551h3.934c.058 1.265.231 2.488.5 3.651zm.553 1.917c.342.976.768 1.881 1.257 2.712-1.223-.49-2.326-1.211-3.256-2.115.636-.229 1.299-.435 1.999-.597zm9.924 0c.7.163 1.362.367 1.999.597-.931.903-2.034 1.625-3.257 2.116.489-.832.915-1.737 1.258-2.713zm.553-1.917c.27-1.163.442-2.386.501-3.651h3.934c-.167 1.672-.748 3.223-1.638 4.551-.877-.358-1.81-.664-2.797-.9zm.501-5.651c-.058-1.251-.229-2.46-.492-3.611.992-.237 1.929-.546 2.809-.907.877 1.321 1.451 2.86 1.616 4.518h-3.933z" />
        </svg>
      ),
      color: "from-blue-500 to-cyan-500",
    },
  ].filter((link) => link.url && link.url.trim() !== "");

  const handleSocialClick = (url) => {
    if (!url) return;
    
    // Lowercase the URL to prevent impersonation warnings
    const lowercaseUrl = url.toLowerCase();
    
    let fullUrl = lowercaseUrl;
    if (!fullUrl.startsWith("http://") && !fullUrl.startsWith("https://")) {
      fullUrl = `https://${fullUrl}`;
    }
    window.open(fullUrl, "_blank");
  };

  // Generate gradient from brand color
  const generateGradient = (baseColor) => {
    const hex = baseColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Calculate luminance to determine if color is dark or light
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    const isDark = luminance < 0.5;

    let shade1R, shade1G, shade1B, shade2R, shade2G, shade2B;

    if (isDark) {
      // For dark colors, create darker variations
      shade1R = Math.min(255, r + 100);
      shade1G = Math.min(255, g + 100);
      shade1B = Math.min(255, b + 100);
      shade2R = Math.min(255, r + 50);
      shade2G = Math.min(255, g + 50);
      shade2B = Math.min(255, b + 50);
    } else {
      // For light colors, create lighter variations
      shade1R = Math.min(255, r + 40);
      shade1G = Math.min(255, g + 40);
      shade1B = Math.min(255, b + 40);
      shade2R = Math.min(255, r + 20);
      shade2G = Math.min(255, g + 20);
      shade2B = Math.min(255, b + 20);
    }

    const shade1 = `rgb(${shade1R}, ${shade1G}, ${shade1B})`;
    const shade2 = `rgb(${shade2R}, ${shade2G}, ${shade2B})`;
    const base = `rgb(${r}, ${g}, ${b})`;

    return isDark 
      ? `linear-gradient(to bottom right, ${shade1}, ${shade2}, ${base})`
      : `linear-gradient(to bottom right, ${shade1}, ${shade2}, ${base})`;
  };

  // Calculate if text should be white or black based on background luminance
  const getTextColor = (hexColor) => {
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Calculate relative luminance (WCAG formula)
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // Return white for dark backgrounds, black for light backgrounds
    return luminance > 0.5 ? '#1f2937' : '#ffffff'; // gray-800 or white
  };

  const brandColor = person.socialMediaConfig?.brandColor || "#2563EB";
  const gradientStyle = generateGradient(brandColor);
  const textColor = getTextColor(brandColor);

  const [drawerOpen, setDrawerOpen] = useState(false);

  // Auto-open drawer after 1 second
  useEffect(() => {
    const timer = setTimeout(() => {
      setDrawerOpen(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex flex-col h-full items-center min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 justify-start p-6 pb-32">
      <div className="max-w-md w-full relative z-10">
        {/* Header Card with Animated Gradient */}
        <div className="relative bg-white rounded-3xl shadow-sm border border-gray-100 p-8 mb-6 overflow-hidden">
          {/* Animated Gradient Background */}
          <div className="absolute inset-0">
            <div 
              className="absolute inset-0 animate-gradient-shift"
              style={{
                background: gradientStyle,
                backgroundSize: '200% 200%',
              }}
            ></div>
          </div>
          
          {/* Content */}
          <div className="relative z-10 text-center">
            {person.imageUrl && (
              <motion.div
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
                className="relative inline-block mb-5"
              >
                {/* White Card Container */}
                <div className="bg-white p-2 rounded-2xl shadow-md">
                  <img
                    src={person.imageUrl}
                    alt={person.businessName || "Business"}
                    className="w-24 h-24 rounded-xl object-cover"
                  />
                </div>
              </motion.div>
            )}
            <motion.h1
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="text-2xl font-semibold mb-2 tracking-tight"
              style={{ color: textColor }}
            >
              {person.businessName || "Business"}
            </motion.h1>
            <motion.p
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="text-sm font-medium"
              style={{ color: textColor, opacity: 0.8 }}
            >
              {person.socialMediaConfig?.tagline || "Connect with us"}
            </motion.p>
          </div>
        </div>

        {/* Festive Bento Card */}
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="relative bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden h-48 mb-6"
        >
          {/* Christmas Image Background */}
          <img
            src={
              person.socialMediaConfig?.bannerImage ||
              require("../Assets/img/xmas/house.png")
            }
            alt="banner"
            className="absolute inset-0 w-full h-full object-cover"
          />
          
          {/* Time Overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent flex flex-col justify-end p-6">
            <div className="text-white">
              <div className="text-3xl font-bold tracking-tight mb-1">
                {formatTime()}
              </div>
              <div className="text-sm opacity-90">
                {formatDate()}
              </div>
            </div>
          </div>
        </motion.div>

        {/* Social Links - Shown when drawer is closed */}
        {!drawerOpen && socialLinks.length > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className="flex flex-col gap-3 mb-6"
          >
            {socialLinks.map((link, index) => (
              <motion.button
                key={index}
                initial={{ y: -20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.3, delay: index * 0.1 }}
                onClick={() => handleSocialClick(link.url)}
                className="group relative bg-white rounded-2xl p-5 shadow-sm border border-gray-100 hover:shadow-md hover:scale-[1.01] transition-all duration-200 active:scale-[0.99] w-full"
              >
                <div className="flex items-center gap-4">
                  <div
                    className={`w-12 h-12 rounded-xl bg-gradient-to-br ${link.color} flex items-center justify-center text-white shadow-sm group-hover:shadow-md transition-shadow flex-shrink-0`}
                  >
                    {link.icon}
                  </div>
                  <span className="text-base font-medium text-gray-700 group-hover:text-gray-900 transition-colors">
                    {link.name}
                  </span>
                </div>
              </motion.button>
            ))}
          </motion.div>
        )}

        {/* Open Drawer Button - Shown when drawer is closed */}
        {!drawerOpen && (
          <motion.button
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.5 }}
            onClick={() => setDrawerOpen(true)}
            className="w-full text-white font-semibold py-4 px-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-200 active:scale-[0.98]"
            style={{ backgroundColor: '#2563EB' }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#1d4ed8'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#2563EB'}
          >
            View All Links
          </motion.button>
        )}
      </div>

      {/* iOS-Style Drawer for Social Links */}
      <Drawer.Root open={drawerOpen} onOpenChange={setDrawerOpen}>
        <Drawer.Portal>
          <Drawer.Overlay className="fixed inset-0 bg-black/40 z-40" />
          <Drawer.Content
            className="fixed bottom-0 left-0 right-0 bg-white rounded-t-3xl shadow-2xl border-t border-gray-100 max-w-md mx-auto outline-none z-50"
            style={{ maxHeight: "70vh" }}
          >
            {/* Drawer Handle */}
            <div className="flex justify-center pt-3 pb-2">
              <div className="w-10 h-1 bg-gray-300 rounded-full"></div>
            </div>

            {/* Drawer Content */}
            <div className="px-6 pb-8 overflow-y-auto" style={{ maxHeight: "calc(70vh - 40px)" }}>
              <h3 className="text-lg font-semibold text-gray-900 mb-4 text-center">
                Follow Us
              </h3>

              {/* Social Links */}
              {socialLinks.length > 0 ? (
                <div className="flex flex-col gap-3">
                  {socialLinks.map((link, index) => (
                    <motion.button
                      key={index}
                      initial={{ y: -20, opacity: 0 }}
                      animate={{ y: 0, opacity: 1 }}
                      transition={{ duration: 0.3, delay: 0.2 + index * 0.1 }}
                      onClick={() => handleSocialClick(link.url)}
                      className="group relative bg-gray-50 rounded-2xl p-5 hover:bg-gray-100 transition-all duration-200 active:scale-[0.98] w-full"
                    >
                      <div className="flex items-center gap-4">
                        <div
                          className={`w-12 h-12 rounded-xl bg-gradient-to-br ${link.color} flex items-center justify-center text-white shadow-sm group-hover:shadow-md transition-shadow flex-shrink-0`}
                        >
                          {link.icon}
                        </div>
                        <span className="text-base font-medium text-gray-700 group-hover:text-gray-900 transition-colors">
                          {link.name}
                        </span>
                      </div>
                    </motion.button>
                  ))}
                </div>
              ) : (
                <div className="bg-gray-50 rounded-2xl p-8 text-center">
                  <p className="text-gray-500 text-sm">
                    No social media links available
                  </p>
                </div>
              )}
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
};

const CreateProfile = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [intro, setIntro] = useState(true);
  const [answers, setAnswers] = useState(defaultProfile);
  const { id } = useParams();
  const isSubmittingRef = useRef(false); // Prevent double submission

  const handleSubmit = (answers) => {
    setModalOpen(true);

    answers = { ...answers, cardId: id };
    setAnswers(answers);
    setUser(formatAnswersToUserObject(answers));
  };

  const [user, setUser] = useState({});
  const { userLoggedIn, currentUser, setCardId } = useAuth();

  const formatAnswersToUserObject = (answers) => {
    const usertoStore = {
      cardId: id,
      firstName: answers.firstName,
      lastName: answers.lastName,
      email: currentUser?.email?.toLowerCase() || answers.email?.toLowerCase(),
      phone: answers.phone,
      college: answers.college,
      createdAt: new Date(),
      isAdmin: false,
      visits: 0,
      isVerified: false,
      contacts: [],
      profiles: [
        {
          firstName: answers.firstName,
          lastName: answers.lastName,
          imageUrl: answers.imageUrl,
          email:
            answers.email?.toLowerCase() || currentUser?.email?.toLowerCase(),
          phone: answers.phone,
          college: answers.college,
          linkedIn: answers.linkedIn,
          x: answers.xUrl,
          instagram: answers.instagram,
          github: answers.github,
          portfolio: answers.portfolio,
          resume: answers.resume,
          additional: answers.additional,
          headline: answers.headline,
          degreeType: answers.degreeType,
          major: answers.major,
          collegeStartYear: answers.collegeStartYear,
          collegeStartMonth: answers.collegeStartMonth,
          collegeEndYear: answers.collegeEndYear,
          collegeEndMonth: answers.collegeEndMonth,
          // Business-specific fields
          businessName: answers.businessName,
          googleReviewLink: answers.googleReviewLink,
          facebook: answers.facebook,
          tiktok: answers.tiktok,
          // Business-specific fields
          businessName: answers.businessName,
          googleReviewLink: answers.googleReviewLink,
          // Profile-specific fields
          cardType: answers.cardType,
          businessPurpose: answers.businessPurpose,
        },
      ],
      // Root level fields - kept for backward compatibility/indexing if needed
      cardType: answers.cardType,
      businessPurpose: answers.businessPurpose,
    };
    setUser(usertoStore);

    return usertoStore;
  };

  const handleConfirm = async () => {
    // Prevent double submission
    if (isSubmittingRef.current) {
      return;
    }

    isSubmittingRef.current = true;

    // Check if this is a gift card
    if (answers.cardType === "gift") {
      try {
        // 1. Create/Update User Profile for the card
        // This ensures the card is "claimed" and visiting /profile/:id works
        const giftUser = {
          cardId: id,
          firstName: answers.recipientName,
          lastName: "", // Optional for gifts
          email: currentUser?.email?.toLowerCase() || answers.email?.toLowerCase(),
          cardType: "gift",
          createdAt: new Date(),
          profiles: [
            {
              firstName: answers.recipientName,
              cardType: "gift",
              email: currentUser?.email?.toLowerCase() || answers.email?.toLowerCase(),
            },
          ],
        };

        await axios.post(
          `${process.env.REACT_APP_PUBLIC_BACKEND_URL}save_user`,
          giftUser
        );

        // 2. Create Gift Session
        const res = await axios.post(
          `${process.env.REACT_APP_PUBLIC_BACKEND_URL}create_gift`,
          {
            buyerId: currentUser?.uid || "anonymous", // Or handle auth if needed
            cardId: id,
            recipientName: answers.recipientName,
            occasion:
              answers.occasion === "Other"
                ? answers.otherOccasion
                : answers.occasion,
            senderName: answers.senderName,
            endingMessage: answers.endingMessage,
          }
        );

        if (res.data && res.data.giftId) {
          // Redirect to upload page with onboarding flag
          window.location.href = `/gift/${res.data.giftId}/contribute?onboarding=true`;
          return;
        }
      } catch (error) {
        console.error("Error creating gift:", error);
        isSubmittingRef.current = false;
        // You might want to show a toast error here
        return;
      }
    }

    //post request with answers
    const usertoStore = formatAnswersToUserObject(answers);
    try {
      await axios.post(
        `${process.env.REACT_APP_PUBLIC_BACKEND_URL}save_user`,
        usertoStore
      );
    } catch (error) {
      console.error("Error saving user:", error);
      isSubmittingRef.current = false; // Reset on error
      return;
    }

    setModalOpen(false);
    window.location.reload();
  };

  return (
    <CreateProfileForm
      intro={intro}
      setIntro={setIntro}
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      handleSubmit={handleSubmit}
      handleConfirm={handleConfirm}
      answers={answers}
      setAnswers={setAnswers}
    />
  );
};

export default NewProfile;
